import { createActions } from 'redux-actions';

const actions = createActions({
  TASK: {
    CLEAN_TASK: undefined,
    API: {
      CLEAN_TAST: undefined
    }
  }
})

const configuration = {
  name: 'cleanTask',
  action: actions,
  sagas: undefined,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      createTask: undefined
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/cleanTask.js